//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { system } from '@/util/const'

export default {
  data () {
    return {
      isIos: system()
    }
  },
  created () {

  },
  methods: {
    jump () {
      if (this.isIos === 'ios') {
        window.location.href = 'https://itunes.apple.com/app/id483513425'
      } else {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.ChinaMobile'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/guide.vue